import { render, staticRenderFns } from "./StudentsDebt.vue?vue&type=template&id=0390fd6a&"
import script from "./StudentsDebt.vue?vue&type=script&lang=js&"
export * from "./StudentsDebt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports